// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style__wrapper__tnoyY","header":"style__header__mgTqY","content":"style__content__tfal-"};